/**
 * Dual CSS loader.
 * Quality target: Tailwind v4 (modern).
 * Fallback: Tailwind v3.4 CSS for browsers without color-mix (Chrome < 111, etc.).
 *
 * Local force: ?css=legacy | ?css=modern
 */

export type CssEngine = "modern" | "legacy"

function forcedEngine(): CssEngine | null {
    try {
        const value = new URLSearchParams(window.location.search).get("css")
        if (value === "legacy" || value === "modern") return value
    } catch {
        /* ignore */
    }
    return null
}

function supportsModernCss(): boolean {
    return typeof CSS !== "undefined" && CSS.supports("color", "color-mix(in srgb, red, blue)")
}

function markEngine(engine: CssEngine) {
    document.documentElement.dataset.cssEngine = engine
}

async function importModern(): Promise<void> {
    await import("./styles.css")
    markEngine("modern")
}

async function importLegacy(): Promise<void> {
    await import("./styles.legacy.css")
    markEngine("legacy")
}

export async function loadStyles(): Promise<void> {
    const forced = forcedEngine()
    const preferModern = forced ? forced === "modern" : supportsModernCss()

    if (preferModern) {
        try {
            await importModern()
            return
        } catch (error) {
            console.warn("[styles] modern CSS failed, falling back to legacy", error)
        }
    }

    await importLegacy()
}
